import React, { useEffect, useState } from 'react'
import _ from 'underscore'
import $ from 'jquery'
import Select, { components } from 'react-select'
import { defaultSelectStyles } from '../../config/styles'

const CustomRadio = ({ isSelected }) => (
  <span
    style={{
      display: 'inline-block',
      width: '16px',
      height: '16px',
      borderRadius: '50%',
      border: `1px solid ${isSelected ? '#0075cb' : '#b2b2b2'}`,
      marginRight: '8px',
      position: 'relative',
      backgroundColor: `${isSelected ? '#e6f1fa' : '#eeeeee'}`
    }}
  >
    {isSelected && (
      <span
        style={{
          position: 'absolute',
          top: '3px',
          left: '3px',
          width: '10px',
          height: '10px',
          borderRadius: '50%',
          backgroundColor: '#0075cb',
        }}
      />
    )}
  </span>
);

const CustomOption = ({ children, ...props }) => {
  const { label } = props.data;
  return (
    <components.Option {...props}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <CustomRadio isSelected={props.isSelected} />
        <div
          className="option-label"
          style={{
            width: 'calc(100% - 24px)',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap'
          }}
        >{label}</div>
      </div>
    </components.Option>
  );
};

const CustomDropdown = (data = {}) => {
  const {
    selectedOption,
    options,
    placeholder,
    candidateId,
    type,
    showDefaultIndicator = false,
    customStyles = {},
    handleChange = () => {},
    handleKeyDown = () => {},
    customControlClick = () => {},
    onMenuClose = () => {},
    noOptionsMessage = 'No Options',
    isSearchable = true,
  } = data
  return (
    <Select
      tabIndex={4}
      value={selectedOption}
      onMenuOpen={customControlClick}
      onMenuClose={onMenuClose}
      components={!showDefaultIndicator ? {
        DropdownIndicator: () => <span className="icon-dropdown" />,
        Option: CustomOption,
      } : {}}
      classNamePrefix="template-options-dropdown"
      placeholder={placeholder}
      aria-label={`Select a ${placeholder}`}
      options={options}
      isSearchable={isSearchable}
      noOptionsMessage={() => {
        return noOptionsMessage
      }}
      onChange={value => { handleChange(value, candidateId, type) }}
      maxMenuHeight={200}
      menuPlacement={'bottom'}
      styles={!_.isEmpty(customStyles) ? customStyles : defaultSelectStyles}
      menuShouldScrollIntoView={true}
      onKeyDown={e => { handleKeyDown(e) }}
    />
  )
}

export default CustomDropdown
